import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useUnhideContent = () => {
  const unHideContent = useCallback((hideId) => {
    const requestParams = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(
      `${API_BASE_URL}/api/v3/content-hide/${hideId}/`,
      requestParams,
    );
  }, []);
  return useRestMutation(unHideContent);
};

export default useUnhideContent;
